// OnlineConsultation.js
import React, { useState } from "react";
import { FaQuestionCircle, FaPhone, FaVideo, FaComments } from "react-icons/fa";
import "../Style/OnlineConsultation.css";
import doctor from "../Assets/doctor.png";

const OnlineConsultation = ({handleAppointment}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const options = [
    { id: "query", label: "Query", icon: <FaQuestionCircle /> },
    { id: "chat", label: "Chat", icon: <FaComments /> },
    { id: "phone", label: "Phone", icon: <FaPhone /> },
    { id: "video", label: "Video Call", icon: <FaVideo /> },
  ];

  const handleSelect = (id) => {
    setSelectedOption((prev) => (prev === id ? null : id));
  };

  return (
    <div className="container">
      {/* Doctor Image */}
      <div className="image-container">
        <img src={doctor} alt="Doctor" className="doctor-image" />
        <div className="sign-1" style={{ fontSize: "20px",paddingTop:"-10px" }}>
            Dr. R.K. VISHWAKARMA
            <br />
            <span style={{ fontSize: "16px",margin:"5px" }}>
              B.H.M.S , M.D.
            </span>
          </div>
      </div>

      {/* Text and Options */}
      <div className="text-container-1">
        <h1 className="skin-head-1" style={{ fontSize: "42px" }}>
          Start an online chat consultation with a doctor.
        </h1>
        <p className="skin-head-para" style={{ marginTop: "0px" }}>
          Post unlimited follow-ups to the doctor for the next 50 or 100 hours
          by picking one of our clinic chat services. Easily accessible via our
          comprehensive Online consultation app available in both Android and
          iOS.
        </p>
        <div className="doctor-btn-book-div">
          <button className="doctor-btn-book-1" onClick={handleAppointment}>
            Book An Appointment
          </button>
        </div>
        {/* Options
        <div className="options-container">
          {options.map((option) => (
            <div
              key={option.id}
              className={`option ${selectedOption === option.id ? "selected" : ""}`}
              onClick={() => handleSelect(option.id)}
            >
              <input
                type="radio"
                className="select-type-radio"
                checked={selectedOption === option.id}
                readOnly
              />
              <span className="icon">{option.icon}</span>
              <span>{option.label}</span>
            </div>
          ))}
        </div>

        {/* Button */}
        {/* <button
          className="consultation-button"
          disabled={!selectedOption}
        >
          Start Chat Consultation
        </button> */}
      </div>
    </div>
  );
};

export default OnlineConsultation;
